import CONSTANTS from 'client/constants';

/** Tooltip copy for controls disabled because a question is archived. */
export const ARCHIVED_DISABLED_TOOLTIP = 'Not available for archived questions.';

/** Accepts both generated question models (`getStatus()`) and Immutable records (`get('status')`). */
interface QuestionLike {
  getStatus?: () => string;
  get?: (key: string) => unknown;
}

export const isQuestionArchived = (question?: QuestionLike | null): boolean => {
  const status = question?.getStatus?.() ?? question?.get?.('status');
  return status === CONSTANTS.QUESTIONSET_STATUSES.ARCHIVED;
};
